/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from './create-transaction-form.ngfactory';
import * as i3 from '../../../app/components/create-transaction-form';
import * as i4 from '@ngrx/store/src/store';
import * as i5 from '@ngrx/effects/src/actions';
import * as i6 from 'ng2-completer/services/completer-service';
import * as i7 from '../../../app/services/modal';
import * as i8 from '../../../app/components/create-transaction-view';
const styles_CreateTransactionViewComponent:any[] = ([] as any[]);
export const RenderType_CreateTransactionViewComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CreateTransactionViewComponent,data:{}});
function View_CreateTransactionViewComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'button',[['class',
      'tiny ctv__back']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.clickedBackToTransactionTypeSelection()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['Back to select type...']))],
      (null as any),(null as any));
}
function View_CreateTransactionViewComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(1,(null as any),[' (',')'])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CreateTransactionViewComponent_2)),i0.ɵdid(3,
          16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i0.ɵand(0,(null as any),(null as any),
          0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.isBackButtonVisible();
    _ck(_v,3,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.recordTypeOfTransaction;
    _ck(_v,1,0,currVal_0);
  });
}
function View_CreateTransactionViewComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),16,'div',[['class',
      'ctv__record-options-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),15,'ul',[['class',
      'ctv__record-options']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),4,'li',[['class',
      'ctv__record-option fee']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.clickedSelectTypeOfTransaction('fee')) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵeld(3,0,(null as any),(null as any),
      2,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(4,0,(null as any),(null as any),0,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted(-1,(null as any),['Record Fee'])),(_l()(),i0.ɵted(-1,(null as any),['For recording a new receivable amount'])),
      (_l()(),i0.ɵeld(7,0,(null as any),(null as any),4,'li',[['class','ctv__record-option payment']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedSelectTypeOfTransaction('payment')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵeld(8,0,(null as any),(null as any),
          2,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵeld(9,0,(null as any),(null as any),0,'span',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Record Payment'])),(_l()(),i0.ɵted(-1,(null as any),
          ['For recording a new received payment'])),(_l()(),i0.ɵeld(12,0,(null as any),
          (null as any),4,'li',[['class','ctv__record-option credit']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedSelectTypeOfTransaction('credit')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵeld(13,0,(null as any),(null as any),
          2,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵeld(14,0,(null as any),(null as any),0,'span',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Record Credit'])),(_l()(),i0.ɵted(-1,(null as any),
          ['Fore recording a new creditable amount']))],(null as any),(null as any));
}
function View_CreateTransactionViewComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,'div',[['class',
      'ctv__form']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),1,'create-transaction-form',
          ([] as any[]),(null as any),(null as any),(null as any),i2.View_CreateTransactionFormComponent_0,
          i2.RenderType_CreateTransactionFormComponent)),i0.ɵdid(2,245760,(null as any),
          0,i3.CreateTransactionFormComponent,[i4.Store,i5.Actions,i6.CompleterService,
              i7.ModalService],{recordType:[0,'recordType']},(null as any))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.recordTypeOfTransaction;
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
export function View_CreateTransactionViewComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),9,'div',[['class',
      'create-transaction-view']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),8,'div',[['class',
      'ctv__content-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),3,'h1',[['class',
      'ctv__header']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Record Transaction'])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CreateTransactionViewComponent_1)),
      i0.ɵdid(5,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CreateTransactionViewComponent_3)),i0.ɵdid(7,
          16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_CreateTransactionViewComponent_4)),i0.ɵdid(9,16384,
          (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any))],(_ck,_v) => {
    var _co:i8.CreateTransactionViewComponent = _v.component;
    const currVal_0:any = _co.recordTypeOfTransaction;
    _ck(_v,5,0,currVal_0);
    const currVal_1:boolean = !_co.recordTypeOfTransaction;
    _ck(_v,7,0,currVal_1);
    const currVal_2:any = _co.recordTypeOfTransaction;
    _ck(_v,9,0,currVal_2);
  },(null as any));
}
export function View_CreateTransactionViewComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'create-transaction-view',
      ([] as any[]),(null as any),(null as any),(null as any),View_CreateTransactionViewComponent_0,
      RenderType_CreateTransactionViewComponent)),i0.ɵdid(1,245760,(null as any),0,
      i8.CreateTransactionViewComponent,[i4.Store],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CreateTransactionViewComponentNgFactory:i0.ComponentFactory<i8.CreateTransactionViewComponent> = i0.ɵccf('create-transaction-view',
    i8.CreateTransactionViewComponent,View_CreateTransactionViewComponent_Host_0,{recordTypeOfTransaction:'recordTypeOfTransaction'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/create-transaction-view.ngfactory.ts